import React from "react";
import { Link } from "react-router-dom";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { ArrowLeft } from "lucide-react";

export const LEGAL_UPDATED = "June 2026";

export const LegalSection = ({ n, title, children }) => (
  <section className="border-t border-[#2a2a2a] pt-8">
    <h2 className="font-heading text-lg font-semibold mb-3"><span className="text-[#e2ff31] font-mono mr-2">{n}.</span>{title}</h2>
    <div className="text-[#9ca3af] leading-relaxed space-y-3 text-sm sm:text-base">{children}</div>
  </section>
);

export const LegalPage = ({ testid, eyebrow = "Legal", title, intro, children }) => (
  <div className="min-h-screen grain">
    <Navbar />
    <main data-testid={testid} className="relative z-10 max-w-3xl mx-auto px-6 pt-28 pb-16 space-y-8">
      <Link to="/" className="inline-flex items-center gap-1.5 text-sm text-[#9ca3af] hover:text-[#e2ff31] transition-colors"><ArrowLeft className="w-4 h-4" /> Back to the store</Link>
      <div>
        <p className="text-xs font-mono uppercase tracking-widest text-[#e2ff31]">{eyebrow}</p>
        <h1 className="font-heading text-4xl sm:text-5xl font-bold tracking-tight mt-2">{title}</h1>
        <p className="text-sm text-[#6b7280] mt-3">Last updated {LEGAL_UPDATED}</p>
        {intro && <p className="text-[#9ca3af] mt-5 leading-relaxed">{intro}</p>}
      </div>
      {children}
    </main>
    <Footer />
  </div>
);

export const A = ({ to, children }) => <Link to={to} className="text-[#e2ff31] hover:underline">{children}</Link>;
export const Strong = ({ children }) => <strong className="text-[#f3f4f6]">{children}</strong>;
